import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Measure from "react-measure";

import styles from "./layouts.module.scss";

const MetroView = ({ children }) => {
  const element = useRef(null);
  
  const [slidesToScroll, setSlidesToScroll] = useState(4);
  const [width, setWidth] = useState(null);

  const calculateSlidesToScroll = () => {
    const currentElement = ReactDOM.findDOMNode(element.current);
    var slides = currentElement.querySelectorAll(".slick-slide");
    var slide = slides[0];
    var slidesToScroll = Math.floor(1200 / slide.offsetWidth);
    return slidesToScroll;
  };

  useEffect(() => {
    var slidesToScroll = calculateSlidesToScroll();
    setSlidesToScroll(slidesToScroll);
  }, [width]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    dotsClass: styles.dots,
    slidesToShow: 4,
    slidesToScroll: slidesToScroll,
  };
  
  return (
    <Measure
      bounds
      onResize={(contentRect) => {
        var width = contentRect.bounds.width;
        setWidth(width);
      }}
    >
      {({ measureRef }) => (
        <div ref={measureRef} className={styles.carousel}>
          <Slider
            ref={(el) => { element.current = el}}
            {...settings}
          >
            {children}
          </Slider>
        </div>
      )}
    </Measure>
  );
};

export default MetroView;
